<template>
  <CrudList
    title="Product Prices"
    storeName="Prod_prices"
    :parentStoreName="'Companies/'+$route.params.company_id+'/Products'"
    parentUrlKey="product_id"
    labelAddNew="Add new Price"
    :canAdd="true"
    :canEdit="true"
    :canDelete="true"
    btnTitle="Add Price"
    sortable
    canSearch
  >
     <template v-slot:region_id="{ item }">
        <h4> {{(item.region_id && item.region_id.name?item.region_id.name:'')}}</h4>
      </template>
  </CrudList>
</template>

<script>
import CrudList from "@/components/Crud/CrudList";

export default {
  components: { CrudList },
};
</script>
